module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/contacts/img_about02-c21e82b4bbd6f394556c0caa67b02e2d.png";